import { Route } from "react-router";
import { all_routes } from "./all_routes";
import ContactDetails from "../crm/customers";
import Deals from "../crm/deals";
import DealsDetails from "../crm/deals/dealsDetails";
import DealsKanban from "../crm/deals/dealsKanban";

import Register from "../auth/register";
import ForgotPassword from "../auth/ForgotPassword";
import ResetPassword from "../auth/ResetPassword";
import AgentSetup from "../auth/AgentSetup";
import LeadsDetails from "../crm/leads";
import Leads from "../crm/leads/leads";
import Login from "../auth/login";
import Profile from "../settings/generalSettings/profile";
import ContactList from "../crm/customers/customerList";
import LeadsKanban from "../crm/leads/leadskanban";
import ContactGrid from "../crm/customers/customer-kanban";
import Whatsapp from "../crm/chat/Whatsapp";
import Pipeline from "../crm/pipeline";
import AgentDashboard from "../crm/agent-dashboard/Dashboard";
import AdminDashboard from "../crm/admin-dashboard/Dashboard";
import UserDashboard from "../crm/dashboard/Dashboard";
import LinkusClient from "../crm/linkus/LinkusClient";
import ScriptGenerator from "../crm/scriptGenerator/ScriptGenerator";
import ContactFaq from "../crm/leads/ContactFaq";
import AllCalls from "../crm/speakToLead/AllCalls";
import Api from "../crm/settings/Api";
import HelpAndSupport from "../crm/help-and-support/HelpAndSupport";
import SyncAndIntegration from "../crm/settings/SyncAndIntegration";
import ImportAndExport from "../crm/settings/ImportAndExport";
import UpgradePlan from "../crm/plans/UpgradePlan";
import Security from "../crm/settings/Security";
import Calendar from "../crm/calendar/Calendar";
import Agents from "../crm/agents/Agents";
import MyTickets from "../crm/help-and-support/MyTickets";
import CallLogsAndRecordings from "../crm/call-logs-and-recordings/CallLogsAndRecordings";
import ContactStatuses from "../crm/contact-statuses/ContactStatuses";
import ManageTickets from "../crm/settings/generalSettings/ManageTickets";
import ManageCompanies from "../crm/settings/generalSettings/ManageCompanies";
import CompanyDetails from "../crm/settings/generalSettings/CompanyDetails";
import AgentCallLogsAndRecordings from "../crm/agent-call-logs-and-recordings/AgentCallLogsAndRecordings";
import LinkLogin from "../otherPages/LinkLogin";
import Templates from "../crm/templates/Templates";
import Dialer from "../../core/common/dialer/Dialer";

const route = all_routes;

export const publicRoutes = [
  ////role : companyAdmin
  {
    path: route.linkusClient,
    name: "Linkus Client",
    element: <LinkusClient />,
    route: Route,
    title: "Linkus Client",
  },
    {
    path: route.dialer,
    element: <Dialer />,
    route: Route,
    title: "Dialer",
  },
  {
    path: route.dashboard,
    name: "Dashboard",
    element: <UserDashboard />,

    route: Route,
    title: "Dashboard",
  },
  {
    path: route.templates,
    element: <Templates />,
    route: Route,
    title: "Templates",
  },
  {
    path: route.contact_statuses,
    name: "Contact Statuses",
    element: <ContactStatuses />,

    route: Route,
    title: "Contact Statuses",
  },
  {
    path: route.scriptGenerator,
    name: "Script Generator",
    element: <ScriptGenerator />,
    route: Route,
    title: "Script Generator",
  },
  {
    path: route.leadsKanban,
    element: <LeadsKanban />,
    route: Route,
    title: "Leads Kanban",
  },
  {
    path: route.contactDetails,
    element: <ContactDetails />,
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.security,
    element: <Security />,
    route: Route,
    title: "Security",
  },
  {
    path: route.upgradePlan,
    element: <UpgradePlan />,
    route: Route,
    title: "Upgrade Plan",
  },
  {
    path: route.calendar,
    element: <Calendar />,
    route: Route,
    title: "Calendar",
  },
  {
    path: route.agents,
    element: <Agents />,
    route: Route,
    title: "Agents",
  },

  {
    path: route.deals,
    element: <Deals />,
    route: Route,
    title: "Deals",
  },
  {
    path: route.dealsDetails,
    element: <DealsDetails />,
    route: Route,
    title: "Deals Details",
  },
  {
    path: route.dealsKanban,
    element: <DealsKanban />,
    route: Route,
    title: "Deals Kanban",
  },
  {
    path: route.leadsDetails,
    element: <LeadsDetails />,
    route: Route,
    title: "Leads Details",
  },
  {
    path: route.leads,
    element: <Leads />,
    route: Route,
    title: "Leads",
  },
  {
    path: route.contactFaq,
    element: <ContactFaq />,
    route: Route,
    title: "Contact FAQ",
  },
  {
    path: route.allCalls,
    element: <AllCalls />,
    route: Route,
    title: "Calls",
  },
  {
    path: route.api,
    element: <Api />,
    route: Route,
    title: "Api",
  },
  {
    path: route.helpAndSupport,
    element: <HelpAndSupport />,
    route: Route,
    title: "Help And Support",
  },
  {
    path: route.myTickets,
    element: <MyTickets />,
    route: Route,
    title: "My Tickets",
  },
  {
    path: route.syncAndIntegration,
    element: <SyncAndIntegration />,
    route: Route,
    title: "Sync And Integration",
  },
  {
    path: route.importAndExport,
    element: <ImportAndExport />,
    route: Route,
    title: "Import And Export",
  },
  {
    path: route.profile,
    element: <Profile />,
    route: Route,
    title: "Profile",
  },
  {
    path: route.contactList,
    element: <ContactList />,
    route: Route,
    title: "Contact List",
  },
  {
    path: route.Whatsapp,
    element: <Whatsapp />,
    route: Route,
    title: "Whatsapp",
  },
  {
    path: route.contactGrid,
    element: <ContactGrid />,
    route: Route,
    title: "Contact Grid",
  },
  {
    path: route.pipeline,
    element: <Pipeline />,
    route: Route,
    title: "Pipeline",
  },
  {
    path: route.myTickets,
    name: "Tickets",
    element: <MyTickets />,
    route: Route,
    title: "Tickets",
  },
  {
    path: route.callAndRecording,
    name: "Call Logs and Recordings",
    element: <CallLogsAndRecordings />,
    route: Route,
    title: "Call Logs and Recordings",
  },
  {
    path: route.templates,
    element: <Templates />,
    route: Route,
    title: "Templates",
  },

];

export const authRoutes = [
  {
    path: route.register,
    element: <Register />,
    route: Route,
    title: "Register",
  },
  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
    title: "Forgot Password",
  },
  {
    path: route.resetPassword,
    element: <ResetPassword />,
    route: Route,
    title: "Reset Password",
  },
  {
    path: route.agentSetup,
    element: <AgentSetup />,
    route: Route,
    title: "Agent Setup",
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
    title: "Login",
  },
  // {
  //   path: route.linkLogin,
  //   element: <LinkLogin />,
  //   route: Route,
  //   title: "LinkLogin",
  // },
];

export const adminRoutes = [
  ////role : superAdmin
  // {
  //   path: route.adminDashboard,
  //   name: "Companies",
  //   element: <ManageCompanies />,
  //   route: Route,
  //   title: "Companies",
  // },
  {
    path: route.manageTickets,
    element: <ManageTickets />,
    route: Route,
    title: "Manage Tickets",
  },
  {
    path: route.adminCompaniesList,
    element: <ManageCompanies />,
    route: Route,
    title: "Companies",
  },

  {
    path: route.companyDetails,
    element: <CompanyDetails />,
    route: Route,
    title: "Companies",
  },
  {
    path: route.adminProfile,
    element: <Profile />,
    route: Route,
    title: "Agent Profile",
  },
  {
    path: route.adminSecurity,
    element: <Security />,
    route: Route,
    title: "Agent Security",
  },
];
export const agentRoutes = [
  ////role : user
  {
    path: route.agentProfile,
    element: <Profile />,
    route: Route,
    title: "Agent Profile",
  },
  {
    path: route.agentSecurity,
    element: <Security />,
    route: Route,
    title: "Agent Security",
  },
  {
    path: route.agentLinkusClient,
    name: "Agent Call Client",
    element: <LinkusClient />,
    route: Route,
    title: "Agent Call Client",
  },
  {
    path: route.agentDashboard,
    name: "Agent Dashboard",
    element: <AgentDashboard />,
    route: Route,
    title: "Agent Dashboard",
  },
  {
    path: route.agentHelpAndSupport,
    element: <HelpAndSupport />,
    route: Route,
    title: "Help And Support",
  },
  {
    path: route.myTicketsAgent,
    name: "Tickets",
    element: <MyTickets />,
    route: Route,
    title: "Tickets",
  },
  {
    path: "/agent/contact-statuses",
    name: "Contact Statuses",
    element: <ContactStatuses />,

    route: Route,
    title: "Contact Statuses",
  },
  {
    path: route.agentCallAndRecording,
    name: "Tickets",
    element: <AgentCallLogsAndRecordings />,
    route: Route,
    title: "Tickets",
  },
  {
    path: route.agentFaq,
    element: <ContactFaq />,
    route: Route,
    title: "Contact FAQ",
  },
  {
    path: route.agentImportAndExport,
    element: <ImportAndExport />,
    route: Route,
    title: "Import And Export",
  },
  {
    path: route.agentCalendar,
    element: <Calendar />,
    route: Route,
    title: "Calendar",
  },
  {
    path: route.agentLeads,
    element: <Leads />,
    route: Route,
    title: "Leads",
  },
  {
    path: route.agentContactList,
    element: <ContactList />,
    route: Route,
    title: "Contact List",
  },
  {
    path: route.agentContactDetails,
    element: <ContactDetails />,
    route: Route,
    title: "Contact Details",
  },
  {
    path: route.agentLeadsDetails,
    element: <LeadsDetails />,
    route: Route,
    title: "Leads Details",
  },
  {
    path: route.agentDialer,
    element: <Dialer />,
    route: Route,
    title: "Dialer",
  },
  //   {
  //   path: route.syncAndIntegration,
  //   element: <SyncAndIntegration />,
  //   route: Route,
  //   title: "Sync And Integration",
  // },
];
